import styled from 'styled-components'
import Chip from 'presentation/shared/components/Chip'
import Rating from '@material-ui/lab/Rating'
import theme from 'presentation/styles/theme'

export const StyledRate = styled(Rating)`
  label {
    padding: 0 16px !important;
  }
`

export const ChipsContainer = styled.div`
  p {
    margin-bottom: 16px;
    text-align: center;
  }

  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    max-width: 700px;
    margin: auto;
  }
`

export const ChipNew = styled(Chip)`
  & + label {
    border: none !important;
    color: ${theme.ds.colors.neutral600};
    background-color: ${theme.ds.colors.neutral100};
    user-select: none;
  }

  &:checked + label {
    background-color: ${theme.ds.colors.primary300} !important;
  }
`
